import { Link, useLocation } from "react-router-dom";

const Brand = () => (
  <Link to="/" className="brand" data-testid="brand-home">
    <div className="brand-mark">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12s4-8 10-8 10 8 10 8-4 8-10 8-10-8-10-8z"/><circle cx="12" cy="12" r="3"/></svg>
    </div>
    <div>
      <div className="brand-title">Gestion <em>Lagon</em></div>
      <div className="brand-sub">Gestion commerciale · Polynésie</div>
    </div>
  </Link>
);

export default function PublicNav() {
  const loc = useLocation();
  return (
    <nav className="nav-pub">
      <div className="nav-inner">
        <Brand />
        <div className="nav-links">
          <Link to="/pricing" className="nav-link" data-testid="nav-pricing">Tarifs</Link>
          <Link to="/login" className="nav-link" data-testid="nav-login">Connexion</Link>
          <Link to="/signup" className="btn btn-primary btn-sm" data-testid="nav-signup">Essai gratuit 14 jours</Link>
        </div>
      </div>
    </nav>
  );
}
